<template>
  <div>
    <section
      class="box-detail form-detail"
      v-if="
        dataContract.groupService !== 'SELL' &&
        dataContract.lstAppendixCredits &&
        dataContract.lstAppendixCredits.length > 0
      "
    >
      <h1>Phụ lục phí trả góp</h1>
      <div class="table-responsive">
        <table class="table table-hover table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-left">Số phụ lục</th>
              <th scope="col" class="text-left">Thời gian</th>
              <th scope="col" class="text-left">Trạng thái</th>
              <th scope="col" class="text-left">Chi tiết</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in dataContract.lstAppendixCredits" :key="index">
            <tr class="table-row">
              <td align="left">{{ item.code }}</td>
              <td align="left">
                <p v-if="item.dateCreatedAppendixDTO || item.dateCreate">
                  <b>Ngày tạo :</b>
                  {{
                    item.dateCreatedAppendixDTO
                      ? item.dateCreatedAppendixDTO
                      : item.dateCreate | formatDate('HH:mm DD/MM/YYYY')
                  }}
                </p>
                <p
                  v-if="
                    item.state &&
                    (item.state === 'SIGNED_WAITING_APPROVED' ||
                      item.state === 'APPROVED' ||
                      item.state === 'REJECTED_SA') &&
                    (item.dateSignAppendixDTO || item.dateSign)
                  "
                >
                  <b>Ngày ký :</b>
                  {{
                    item.dateSignAppendixDTO ? item.dateSignAppendixDTO : item.dateSign | formatDate
                  }}
                </p>
                <p v-if="item.state && item.state === 'CANCELED' && item.dateCancelDTO">
                  <b>Ngày huỷ :</b> {{ item.dateCancelDTO | formatDate }}
                </p>
              </td>
              <td align="left">
                <span class="badge" v-bind:class="[item.state ? item.state : '']">{{
                  item.state ? item.state : '' | mapTextStatus(listStatusContract)
                }}</span>
              </td>
              <td align="left">
                <span
                  @click="showFeeModalCredit(item.appendixCredit.creditFeeTable)"
                  v-if="item.isDefaultFee"
                  ><span class="text-info">Xem phí mặc định</span></span
                >
                <span
                  @click="showFeeModalCredit(item.appendixCredit.creditFeeTable)"
                  v-if="!item.isDefaultFee"
                  ><span class="text-info">Xem phí đề xuất</span></span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <div v-if="showFeeCredit">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Biểu phí trả góp</h5>
                  <button type="button" @click="showFeeCredit = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center" style="max-height: 400px; overflow-y: auto">
                  <div class="table-price table-bordered table-responsive text-center">
                    <table>
                      <thead>
                        <tr class="bg-head2 text-center">
                          <th width="15%" rowspan="2"><b>Ngân hàng</b></th>
                          <th colspan="7"><b>Kỳ hạn trả góp</b></th>
                          <th id="th7" width="15%" rowspan="2">
                            <b>Mức giao dịch tối thiểu (VNĐ)</b>
                          </th>
                        </tr>
                        <tr class="bg-head2 text-center">
                          <th width="10%"><b>3 tháng</b></th>
                          <th width="10%"><b>6 tháng</b></th>
                          <th width="10%"><b>9 tháng </b></th>
                          <th width="10%"><b>12 tháng </b></th>
                          <th width="10%"><b>18 tháng</b></th>
                          <th width="10%"><b>24 tháng</b></th>
                          <th width="10%"><b>36 tháng</b></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in dataTariff" :key="index">
                          <td class="txt-center">{{ item.bankName }}</td>
                          <td class="txt-center">
                            <span
                              style="background: yellow"
                              v-if="
                                item.listPeriod.filter(e => e.period === '3')[0] &&
                                item.listPeriod.filter(e => e.period === '3')[0].isDefaultFee ===
                                  false
                              "
                            >
                              {{ '3' | mapA(item.listPeriod) }}
                            </span>
                            <span v-else>
                              {{ '3' | mapA(item.listPeriod) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              style="background: yellow"
                              v-if="
                                item.listPeriod.filter(e => e.period === '6')[0] &&
                                item.listPeriod.filter(e => e.period === '6')[0].isDefaultFee ===
                                  false
                              "
                            >
                              {{ '6' | mapA(item.listPeriod) }}
                            </span>
                            <span v-else>
                              {{ '6' | mapA(item.listPeriod) }}
                            </span>
                          </td>
                          <td class="txt-center">
                            <span
                              style="background: yellow"
                              v-if="
                                item.listPeriod.filter(e => e.period === '9')[0] &&
                                item.listPeriod.filter(e => e.period === '9')[0].isDefaultFee ===
                                  false
                              "
                            >
                              {{ '9' | mapA(item.listPeriod) }}
                            </span>
                            <span v-else>
                              {{ '9' | mapA(item.listPeriod) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              style="background: yellow"
                              v-if="
                                item.listPeriod.filter(e => e.period === '12')[0] &&
                                item.listPeriod.filter(e => e.period === '12')[0].isDefaultFee ===
                                  false
                              "
                            >
                              {{ '12' | mapA(item.listPeriod) }}
                            </span>
                            <span v-else>
                              {{ '12' | mapA(item.listPeriod) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              style="background: yellow"
                              v-if="
                                item.listPeriod.filter(e => e.period === '18')[0] &&
                                item.listPeriod.filter(e => e.period === '18')[0].isDefaultFee ===
                                  false
                              "
                            >
                              {{ '18' | mapA(item.listPeriod) }}
                            </span>
                            <span v-else>
                              {{ '18' | mapA(item.listPeriod) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              style="background: yellow"
                              v-if="
                                item.listPeriod.filter(e => e.period === '24')[0] &&
                                item.listPeriod.filter(e => e.period === '24')[0].isDefaultFee ===
                                  false
                              "
                            >
                              {{ '24' | mapA(item.listPeriod) }}
                            </span>
                            <span v-else>
                              {{ '24' | mapA(item.listPeriod) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              style="background: yellow"
                              v-if="
                                item.listPeriod.filter(e => e.period === '36')[0] &&
                                item.listPeriod.filter(e => e.period === '36')[0].isDefaultFee ===
                                  false
                              "
                            >
                              {{ '36' | mapA(item.listPeriod) }}
                            </span>
                            <span v-else>
                              {{ '36' | mapA(item.listPeriod) }}
                            </span>
                          </td>
                          <td class="text-center">
                            {{ item.minAmount | fomatCurrency }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'

  export default {
    props: ['dataContract'],
    data() {
      return {
        listStatusContract: Config.listStatusContract,
        showFeeCredit: false,
        dataTariff: [],
      }
    },
    methods: {
      showFeeModalCredit(data) {
        this.showFeeCredit = true
        this.dataTariff = data
      },
    },
  }
</script>

<style scoped>
  /*Modal Bieu phi*/
  .modal-dialog {
    max-width: 60%;
    overflow-x: auto;
    margin: 0 auto;
  }
  .modal-body {
    width: 100%;
  }
  @media screen and (max-width: 410px) {
    .modal-dialog {
      margin: 0 7%;
      max-width: 76%;
    }
  }
</style>
